export enum OWNER_TYPES {
  Cashier = 1,
  Trader = 2,
  InvoicePerson = 3,
}
